import { Ordrebekreftelse } from "codegen";
import { Route, Routes } from "react-router-dom";

import { FullPageLoading, InfoWrapper } from "components/organisms/FullPageLoading";
import useProducts from "hooks/useProducts";
import { useStrombestillingApiQuery } from "hooks/useStrombestillingApi";
import EditOrderConfirmationPage from "pages/Productadmin/EditOrderConfirmationPage";
import EditProductPage from "pages/Productadmin/ProductPage/EditProductPage";
import ProductsPage from "pages/Productadmin/ProductsPage";

function FullPageErrorMessage(error?: string) {
	return (
		<InfoWrapper>
			<span>{error || "Fant ikke nødvendig data, prøv igjen senere"}</span>
		</InfoWrapper>
	);
}

export default function ProductsTopPage() {
	const { products, isLoadingProducts, isRefetchingProducts } = useProducts();

	const { data: orderConfirmations, isLoading: orderConfirmationsLoading } = useStrombestillingApiQuery<Ordrebekreftelse[]>(
		"/order-confirmations/templates",
		["order-confirmations"]
	);

	return (
		<Routes>
			<Route
				index
				element={
					isLoadingProducts || orderConfirmationsLoading ? (
						FullPageLoading()
					) : !products?.length || !orderConfirmations?.length ? (
						FullPageErrorMessage()
					) : (
						<ProductsPage products={products} orderConfirmations={orderConfirmations} />
					)
				}
			/>
			<Route
				path=":tariffId"
				element={
					(isLoadingProducts || orderConfirmationsLoading) && !isRefetchingProducts ? (
						FullPageLoading()
					) : !products?.length || !orderConfirmations?.length ? (
						FullPageErrorMessage()
					) : (
						<EditProductPage products={products} orderConfirmations={orderConfirmations} />
					)
				}
			/>
			<Route
				path="order-confirmations/:orderConfirmationId"
				element={
					isLoadingProducts || orderConfirmationsLoading ? (
						FullPageLoading()
					) : !products?.length || !orderConfirmations?.length ? (
						FullPageErrorMessage()
					) : (
						<EditOrderConfirmationPage products={products} orderConfirmations={orderConfirmations} />
					)
				}
			/>
		</Routes>
	);
}
